var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54492 0.680393C7.54492 0.304612 7.84953 0 8.22532 0H16.39C16.7658 0 17.0704 0.304612 17.0704 0.680393C17.0704 1.05617 16.7658 1.36079 16.39 1.36079H8.22532C7.84953 1.36079 7.54492 1.05617 7.54492 0.680393Z",
    fill: "#8F96A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54492 3.405C7.54492 3.02922 7.84953 2.72461 8.22532 2.72461H16.39C16.7658 2.72461 17.0704 3.02922 17.0704 3.405C17.0704 3.78078 16.7658 4.0854 16.39 4.0854H8.22532C7.84953 4.0854 7.54492 3.78078 7.54492 3.405Z",
    fill: "#8F96A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54492 8.8425C7.54492 8.46672 7.84953 8.16211 8.22532 8.16211H16.39C16.7658 8.16211 17.0704 8.46672 17.0704 8.8425C17.0704 9.21828 16.7658 9.5229 16.39 9.5229H8.22532C7.84953 9.5229 7.54492 9.21828 7.54492 8.8425Z",
    fill: "#8F96A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54492 11.5671C7.54492 11.1913 7.84953 10.8867 8.22532 10.8867H16.39C16.7658 10.8867 17.0704 11.1913 17.0704 11.5671C17.0704 11.9429 16.7658 12.2475 16.39 12.2475H8.22532C7.84953 12.2475 7.54492 11.9429 7.54492 11.5671Z",
    fill: "#8F96A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09907 9.5229V11.5641H4.14025V9.5229H2.09907ZM1.41867 8.16211H4.82064C5.19642 8.16211 5.50103 8.46672 5.50103 8.8425V12.2445C5.50103 12.6203 5.19642 12.9249 4.82064 12.9249H1.41867C1.04291 12.9249 0.738281 12.6203 0.738281 12.2445V8.8425C0.738281 8.46672 1.04291 8.16211 1.41867 8.16211Z",
    fill: "#8F96A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98214 0.19927C6.24783 0.464964 6.24783 0.895789 5.98214 1.16148L2.77946 4.36416L0.937562 2.52227C0.671854 2.25658 0.671854 1.82575 0.937562 1.56006C1.20328 1.29436 1.63407 1.29436 1.89979 1.56006L2.77946 2.43974L5.01993 0.19927C5.28562 -0.0664234 5.71645 -0.0664234 5.98214 0.19927Z",
    fill: "#8F96A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.754afe7bdbd85a70ef64b7b0da1d890f.svg";
export { ForwardRef as ReactComponent };